export const APP_ENV = (
  process.env.REACT_APP_ENV ||
  process.env.NODE_ENV ||
  'development'
).toLowerCase();

export const isDevelopment = APP_ENV === 'development';
export const isStaging = APP_ENV === 'staging';
export const isProduction = APP_ENV === 'production';

export const isProdLike = isProduction || isStaging;
